module.exports = __webpack_public_path__ + "static/media/arrow-down-gray.6f125288.svg";